// @flow

import React from "react";

import { saveAs } from "file-saver";
import Button from "../Button";
import FileWidget from "../FileWidget";
import { type IndicatorStyle } from "../FileWidget/FileWidget";
import DownloadCheckmarkIcon from "../../assets/icons/file/download-checkmark.svg";
import DownloadCrossIcon from "../../assets/icons/file/download-cross.svg";

type DownloadStatus = "not_uploaded" | "uploaded" | "downloaded";

type DownloadWidgetProps = {
  downloadAction: ({ id: number }) => Promise<any>,
  id: number,
  status: DownloadStatus,
  title: string,
  filename: string,
  errorCallback: (Error | DOMError) => void,
  successCallback: () => void,
  uploadDate: string
};

const downloadStatusToIndicatorStyle: DownloadStatus => IndicatorStyle = (
  status: DownloadStatus
) => {
  if (status === "downloaded") return "green";
  if (status === "uploaded") return "green-dashed";
  return "red";
};

class DownloadWidget extends React.Component<DownloadWidgetProps> {
  static defaultProps = {
    errorCallback: () => {},
    successCallback: () => {}
  };

  download = () => {
    const { downloadAction, id, filename, errorCallback, successCallback } = this.props;
    downloadAction({ id })
      .then(res => {
        const contentType = res.headers["content-type"];
        const blob = new Blob([res.data], {
          type: contentType
        });

        saveAs(blob, filename);
        successCallback();
      })
      .catch(err => {
        const status = err.response && err.response.status;

        errorCallback(status);
      });
  };

  render() {
    const { status, title, uploadDate } = this.props;
    const isNotUploaded = status === "not_uploaded";
    const icon = isNotUploaded ? DownloadCrossIcon : DownloadCheckmarkIcon;
    return (
      <div>
        <FileWidget
          cta={() =>
            !isNotUploaded && (
              <Button size="small" onClick={this.download}>
                Jetzt herunterladen
              </Button>
            )
          }
          uploadDate={uploadDate}
          moveIndicator={isNotUploaded}
          indicatorStyle={downloadStatusToIndicatorStyle(status)}
          icon={icon}
          title={title}
        />
      </div>
    );
  }
}

export default DownloadWidget;
